import { IReportingPeriodService } from "../../service/reporting/ReportingPeriodService";

export default class SelectForAdditionalCheckInteractor {
  private reportingPeriodService: IReportingPeriodService;

  constructor(reportingPeriodService) {
    this.reportingPeriodService = reportingPeriodService;
  }

  async execute(
    reportingPeriodId: number,
    percentage: number,
    periodFrom?: Date,
    periodTo?: Date,
    min?: number,
    max?: number
  ) {
    return this.reportingPeriodService.selectForAdditionalCheck(
      reportingPeriodId,
      percentage,
      periodFrom,
      periodTo,
      min,
      max
    );
  }
}
